import { AxiosResponse } from 'axios';
import ITransformedValue from '@/ship/Values/ITransformedValue';
import { IChat } from '@/ship/Models/Chats';
import Http from '@/ship/Http';

export const readChatMessages = (chatId: number): Promise<AxiosResponse<ITransformedValue<IChat>>> =>
    Http.get(`/chat/${chatId}/read`);
